import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {RouteService} from "../../services/routeService";
import {AuthService} from "../../services/authService";
import {GeneralService} from "../../services/generalService";
import {LookAndFeelService} from "../../services/lookAndFeelService";
import {DICTIONARY} from "../../dictionary";

// CC: consent step of the MCP OAuth flow. The backend sent the browser here from its /authorize endpoint;
// the decision returns the redirect back to the MCP client (with the authorization code, or access_denied)
@Component({
	selector: 'mcp-authorize-component',
	templateUrl: './mcp-authorize.component.html',
})
export class McpAuthorizeComponent implements OnInit {
	constructor(private activatedRoute: ActivatedRoute,
				private router: Router,
				private rs: RouteService,
				private authService: AuthService,
				private lfs: LookAndFeelService,
				public gs: GeneralService) {
	}

	dic = DICTIONARY;
	corpname = this.gs.corpname;
	logo = this.lfs.appDefaultLogo;

	requestId;
	authorizationRequest;
	userEmail;
	error;
	loading;
	decision;

	ngOnInit() {
		this.requestId = this.activatedRoute.snapshot.paramMap.get('requestId');
		this.loading = true;

		this.gs.getUserInfo(false, (userInfo) => {
			this.userEmail = userInfo?.email;
		});

		this.rs.getMcpAuthorization(this.requestId).then(response => {
			this.authorizationRequest = response;
			this.loading = false;
		}).catch(err => {
			this.error = err?.data?.message || 'This authorization request is no longer valid. Start the connection again from your MCP client.';
			this.loading = false;
		});
	}

	decide(action) {
		this.decision = action;
		this.error = null;

		this.rs.decideMcpAuthorization(this.requestId, {action}).then(response => {
			window.location.assign(response.redirect_url);
		}).catch(err => {
			this.error = err?.data?.message || 'Failed to complete the authorization. Start the connection again from your MCP client.';
			this.decision = null;
		});
	}

	// CC: taken from app-routing.module.ts -> authGuard
	switchAccount() {
		this.authService.setReturnUrl(this.router.url);
		this.authService.logout(false);
		this.router.navigate([DICTIONARY.CONSTANTS.appStates.login]);
	}
}
